import { StepProps } from '@shared/vendor/clutter_staircase';

import { BaseAddedStepProps, BaseValues } from '@portal/components/orders/estimation/data';
import { HydrateVirtualWalkthroughFlowQuery } from '@portal/schema';

import { estimationFitEnum } from './plan';

export enum StepName {
  ItemInventory = 'Item Inventory',
  Photos = 'Photos',
  Notes = 'Notes',
  Review = 'Review',
  Plan = 'Plan',
}

export const FLOW_STEPS_MAP: Record<string, { dataFields: string[] }> = {};

export type Values = { estimationFit?: estimationFitEnum } & BaseValues;

export type AddedStepProps = BaseAddedStepProps & { order: HydrateVirtualWalkthroughFlowQuery['order'] };

export type StepType = StepProps<Values, AddedStepProps>;
